module.exports = __webpack_public_path__ + "static/media/product2.3f23e9db.png";